const safetyTruckKeys = {
  all: ['SAFETY_TRUCK'],
  listData: () => [...safetyTruckKeys.all, 'GET_LIST_DATA'],
  specificDataBase: () => [...safetyTruckKeys.all, 'GET_SPECIFIC_DATA'],
  specificData: ({ seq }) => [...safetyTruckKeys.specificDataBase(), seq],
};

export default safetyTruckKeys;
